import AppointmentStates from "./AppointmentStates";

interface ActivityMetricsInput {
  meetingsCount: number;
  recapsCount: number;
  dismissalsCount: number;
  openTodosCount: number;
  meetingStates?: {
    planned: number;
    documented: number;
    noReport: number;
    didNotTakePlace: number;
  } | null;
}

export default class ActivityMetrics {
  constructor(
    public readonly meetingsCount: number,
    public readonly recapsCount: number,
    public readonly dismissalsCount: number,
    public readonly openTodosCount: number,
    public readonly appointmentStates: AppointmentStates | null = null,
    public readonly markedDoneCount: number | null = null,
  ) {}

  static fromGraphql(data: ActivityMetricsInput): ActivityMetrics {
    return new ActivityMetrics(
      data.meetingsCount,
      data.recapsCount,
      data.dismissalsCount,
      data.openTodosCount,
      data.meetingStates ? AppointmentStates.fromGraphql(data.meetingStates) : null,
    );
  }

  static fromCounts(data: {
    meetings: number;
    recaps: number;
    dismissals: number;
    openTodos: number;
    markedDone?: number | null;
    meetingStates?: {
      planned: number;
      documented: number;
      noReport: number;
      didNotTakePlace: number;
    } | null;
  }): ActivityMetrics {
    return new ActivityMetrics(
      data.meetings,
      data.recaps,
      data.dismissals,
      data.openTodos,
      data.meetingStates ? AppointmentStates.fromGraphql(data.meetingStates) : null,
      data.markedDone ?? null,
    );
  }
}
